// extracted by mini-css-extract-plugin
module.exports = {"noData":"Chart_noData__V5pzr"};